module.exports = __webpack_public_path__ + "static/media/Ornn.c85a85ae.png";